export const getAmountPercent = (values, fieldValueType, fieldName) => {
  if (values[fieldValueType] === `${fieldName}-amount`) {
    return values[fieldName] ? parseFloat(values[fieldName]).toFixed(2) : 0;
  } else {
    return values[fieldName] ? [values[fieldName], '%'].join('') : 0;
  }
};